import { APIResponse } from '../../types/APIResponse';

export const getResponseData = <T>(response: APIResponse<T>): T => response.data;

export const getTotalCountHeader = <T>(response: APIResponse<T>): number | null => {
  const totalCountHeader = response.headers['x-total-count'];

  return totalCountHeader ? parseInt(totalCountHeader, 10) : null;
};
